import { render } from "./ErrorsModal.vue?vue&type=template&id=16bc2d20&scoped=true"
import script from "./ErrorsModal.vue?vue&type=script&lang=js"
export * from "./ErrorsModal.vue?vue&type=script&lang=js"

import "./ErrorsModal.vue?vue&type=style&index=0&id=16bc2d20&scoped=true&lang=scss"

import exportComponent from "/Users/pavel/FrontReportTechnomoscow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bc2d20"]])

export default __exports__